module.exports = __webpack_public_path__ + "img/mobilehardwareOpen5.a248b18a.png";